const STORAGE_KEY = "delegate-auth-context";

const normalize = (raw = {}) => {
  const cohort = raw.cohort || "";
  const commissionId =
    raw.commissionId || raw.commissionsId || raw.commisionId || "";
  const delegateId = raw.delegateId || "";
  const documento = raw.documento || raw.document || raw.ti || "";
  const role = raw.role || raw.accessType || (documento ? "president" : "delegate");

  return {
    cohort: String(cohort).trim(),
    commissionId: String(commissionId).trim(),
    delegateId: String(delegateId).trim(),
    documento: String(documento).trim(),
    role: String(role).trim() || "delegate",
  };
};

export const hasValidContext = (context = {}) => {
  const role = String(context.role || "delegate").toLowerCase();

  if (role === "president") {
    return Boolean(context.cohort && context.commissionId && context.documento);
  }

  return Boolean(context.cohort && context.commissionId && context.delegateId);
};

export const saveAuthContext = (rawContext = {}) => {
  const context = normalize(rawContext);

  if (!hasValidContext(context)) {
    return null;
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(context));
  return context;
};

export const getAuthContext = () => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (!value) {
      return null;
    }

    const parsed = JSON.parse(value);
    const context = normalize(parsed);
    return hasValidContext(context) ? context : null;
  } catch (error) {
    return null;
  }
};

export const clearAuthContext = () => {
  localStorage.removeItem(STORAGE_KEY);
};
